const { setCookie, getCookie } = require("../services/cookiesServices");
const { getPrams } = require("../services/getPrams");
const getTrafficSource = require("../services/getTrafficSource");

if (!getCookie("referrer")) setCookie("referrer", document.referrer);

if (!getCookie("wdgtrk_source"))
	setCookie(
		"wdgtrk_source",
		getTrafficSource(document.referrer, window.location.href)
	);

// check if you find an iframe with id iframe
const iframe = document.querySelector("#iframe");
if (iframe && getCookie("wdgtrk_source")) {
	//console.log("iframe found");
	// get the iframe source
	const iframeSrc = iframe.getAttribute("src");
	// split the source by # and get the first part
	let part1 = iframeSrc.split("#")[0];

	// check if the source has a query string
	if (part1.includes("?")) {
		// if it has a query string add & to the end of the source
		part1 += "&";
	} else {
		// if it doesn't have a query string add ? to the end of the source
		part1 += "?";
	}

	// add the source to the source of the iframe
	iframe.setAttribute("src", part1 + "Source=" + getCookie("wdgtrk_source"));
}

const utms = ["utm_campaign", "utm_source", "utm_medium"];
for (let utm of utms) {
	if (getPrams(utm) && !getCookie(utm)) {
		setCookie(utm, getPrams(utm));
	}
}
